




































import { Component, Vue } from 'vue-property-decorator';
import PaginationComponent from '@/components/util/PaginationComponent.vue';
import Page, { EMPTY_PAGE } from '@/dto/taxation/Page';
import SubscriptionPlanDTO from '@/dto/subscription/SubscriptionPlanDTO';
import SubscriptionPlanService from '@/services/SubscriptionPlanService';
import { processError } from '@/utils/ComponentUtils';
import AddSubscriptionPlanModal from '@/components/admin/sublime/AddSubscriptionPlanModal.vue';

@Component({ components: { PaginationComponent } })
export default class SubscriptionPlans extends Vue {
  private page: Page<SubscriptionPlanDTO> = { ...EMPTY_PAGE };
  private pageSize = 20;
  private loading = false;

  mounted(): void {
    this.load(0);
  }

  private changePage(page: number): void {
    this.load(page - 1);
  }

  private load(pageNumber: number): void {
    this.loading = true;
    SubscriptionPlanService.getPlans(pageNumber, this.pageSize).then(
      ok => {
        this.page = ok.data;
        this.loading = false;
      },
      err => {
        this.loading = false;
        processError(err, this);
      }
    )
  }

  private openCreatePlan(): void {
    this.$modal.show(
      AddSubscriptionPlanModal,
      {
        onCreated: () => {
          this.$modal.hideAll();
          this.changePage(1);
        }
      },
      { 
        width: 900,
        height: 'auto'
      }
    )
  }

  private goTo(id: number): void {
    this.$router.push({ name: this.$routeNames.SUBLIME_SUBSCRIPTION_PLAN, params: { id: `${id}` } });
  }

  private displayIssuer(issuer: any): string {
    // Attempt to support either enum string or object
    if (issuer && typeof issuer === 'object') {
      return issuer.fullName || issuer.abbreviation || JSON.stringify(issuer);
    }
    if (typeof issuer === 'string') {
      return this.$stringUtils.enumToFormattedSentence(issuer);
    }
    return String(issuer);
  }
}
